/**
 * fetchAdminAction — V2.N.8 (factorisation)
 *
 * Helper partagé pour appeler les endpoints admin. Remplace les 5
 * copies de `fetchAction()` qui vivaient dans chaque page admin.
 *
 * Construit le header d'auth (JWT admin OU legacy key via
 * adminAuthHeader), fait le fetch, renvoie `data` ou null en cas
 * d'échec / non-autorisé.
 */

import { adminAuthHeader } from './getAdminAuthToken';

export async function fetchAdminAction<T>(
  endpoint: string,
  action: string,
  params: Record<string, string | number> = {},
): Promise<T | null> {
  const authHeader = await adminAuthHeader();
  if (!authHeader.Authorization) return null;
  const qs = new URLSearchParams({
    action,
    ...Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)])),
  });
  const res = await fetch(`${endpoint}?${qs.toString()}`, { headers: authHeader });
  if (!res.ok) return null;
  const json = await res.json();
  return (json?.data ?? null) as T | null;
}

/** Raccourci pour /api/admin/devices. */
export function fetchDevices<T>(action: string, params: Record<string, string | number> = {}): Promise<T | null> {
  return fetchAdminAction<T>('/api/admin/devices', action, params);
}

/** Raccourci pour /api/admin/analytics. */
export function fetchAnalytics<T>(action: string, params: Record<string, string | number> = {}): Promise<T | null> {
  return fetchAdminAction<T>('/api/admin/analytics', action, params);
}
